import React, { Dispatch, FC, SetStateAction } from 'react';

import { Button, Input } from 'components/atoms';
import { ArrowIcon, CrossIcon } from 'components/icons';

import { TranslationType } from 'queries/types/TranslationsResultType';

import './TranslationExamples.scss';

type TranslationExamplesProps = {
  data: TranslationType | null;
  setData: Dispatch<SetStateAction<TranslationType | null>>;
};

const TranslationExamples: FC<TranslationExamplesProps> = ({ data, setData }) => {
  const handleChangeTranslationExample = (index: number, item: number, value: string) => {
    setData((prev) => {
      if (!prev) return null;

      const newExamples: [string, string][] = prev.examples.map((ex, i) => {
        if (i === index) {
          if (item === 0) return [value, ex[1]];
          else return [ex[0], value];
        }
        return ex;
      });

      return {
        ...prev,
        examples: newExamples,
      };
    });
  };

  const handleDeleteTranslationExample = (index: number) => {
    setData((prev) => {
      if (!prev) return null;

      const newExamples = prev.examples.filter((_, i) => i !== index);

      return {
        ...prev,
        examples: newExamples,
      };
    });
  };

  const handleAddTranslationExample = () => {
    setData((prev) => {
      if (!prev) return null;

      const newExamples: [string, string][] = [...prev.examples, ['', '']];

      return {
        ...prev,
        examples: newExamples,
      };
    });
  };

  return (
    <div className={'translation__examples'}>
      <p className={'translation__examples-title'}>Examples</p>
      <div className={'translation__examples-box'}>
        {!data?.examples.length ? (
          <p className={'translation__examples-empty'}>No entries</p>
        ) : (
          <></>
        )}
        {data?.examples.map((item, index) => (
          <div className={'translation__examples-item'} key={index}>
            <Input
              value={item[0]}
              onChange={({ target }) => handleChangeTranslationExample(index, 0, target.value)}
            />
            <div
              className={'translation__examples-icon-box'}
              onClick={() => handleDeleteTranslationExample(index)}
            >
              <ArrowIcon className={'translation__examples-icon translation__examples-iconArrow'} />
              <CrossIcon className={'translation__examples-icon translation__examples-iconCross'} />
            </div>
            <Input
              value={item[1]}
              onChange={({ target }) => handleChangeTranslationExample(index, 1, target.value)}
            />
          </div>
        ))}
        <Button className={'translation__examples-add'} onClick={handleAddTranslationExample}>
          +
        </Button>
      </div>
    </div>
  );
};

export default TranslationExamples;
